import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listPlantUnits } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  ListPlantUnitsRequestSchema,
  type ListPlantUnitsResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/** 電源ユニットの一覧取得 hook。絞り込み・並び・集約は画面側 (`models/unitRows.ts`) で行う。 */
export function useListPlantUnits(): UseQueryResult<
  ListPlantUnitsResponse,
  ConnectError
> {
  return useQuery(listPlantUnits, create(ListPlantUnitsRequestSchema, {}))
}
